import React, { useState, useEffect } from 'react';

const ServiceWorkerDebug = () => {
  const [swStatus, setSwStatus] = useState('Checking...');
  const [swRegistration, setSwRegistration] = useState(null);
  const [isSupported, setIsSupported] = useState(false);

  useEffect(() => {
    checkServiceWorker();
  }, []);

  const checkServiceWorker = async () => {
    // Check if service worker is supported
    if (!('serviceWorker' in navigator)) {
      setSwStatus('❌ Service Worker not supported');
      setIsSupported(false);
      return;
    }

    setIsSupported(true);

    try {
      // Check if service worker is already registered
      const registration = await navigator.serviceWorker.getRegistration();
      
      if (registration) {
        setSwRegistration(registration);
        setSwStatus('✅ Service Worker registered');
        console.log('Service Worker found:', registration);
      } else {
        setSwStatus('⚠️ Service Worker not registered');
        
        // Try to register
        try {
          const newRegistration = await navigator.serviceWorker.register('/sw.js');
          setSwRegistration(newRegistration);
          setSwStatus('✅ Service Worker registered successfully');
          console.log('Service Worker registered:', newRegistration);
        } catch (error) {
          setSwStatus(`❌ Failed to register: ${error.message}`);
          console.error('Service Worker registration failed:', error);
        }
      }
    } catch (error) {
      setSwStatus(`❌ Error: ${error.message}`);
      console.error('Service Worker check failed:', error);
    }
  };

  const testNotification = async () => {
    if (!swRegistration) {
      alert('Service Worker not registered');
      return;
    }

    try {
      await swRegistration.showNotification('Test Notification', {
        body: 'This is a test notification from Paragon!',
        icon: '/logo192.png',
        badge: '/favicon.ico',
        tag: 'test-notification'
      });
    } catch (error) {
      alert(`Notification failed: ${error.message}`);
    }
  };

  const unregisterSW = async () => {
    if (!swRegistration) {
      alert('No service worker to unregister');
      return;
    }

    try {
      await swRegistration.unregister();
      setSwRegistration(null);
      setSwStatus('⚠️ Service Worker unregistered');
    } catch (error) {
      alert(`Unregister failed: ${error.message}`);
    }
  };

  return (
    <div style={{ 
      padding: '20px', 
      border: '1px solid #ccc', 
      margin: '20px',
      borderRadius: '8px',
      backgroundColor: '#f9f9f9'
    }}>
      <h3>🔧 Service Worker Debug</h3>
      
      <div style={{ marginBottom: '10px' }}>
        <strong>Browser Support:</strong> 
        <span style={{ color: isSupported ? 'green' : 'red', marginLeft: '10px' }}>
          {isSupported ? '✅ Supported' : '❌ Not Supported'}
        </span>
      </div>

      <div style={{ marginBottom: '10px' }}>
        <strong>Service Worker Status:</strong> 
        <span style={{ marginLeft: '10px' }}>{swStatus}</span>
      </div>

      <div style={{ marginBottom: '10px' }}>
        <strong>Protocol:</strong> 
        <span style={{ marginLeft: '10px' }}>{window.location.protocol}</span>
        {window.location.protocol === 'https:' || window.location.hostname === 'localhost' ? 
          <span style={{ color: 'green', marginLeft: '10px' }}>✅ Secure</span> : 
          <span style={{ color: 'red', marginLeft: '10px' }}>❌ Not Secure (HTTPS required)</span>
        }
      </div>

      {swRegistration && (
        <div style={{ marginBottom: '10px' }}>
          <strong>Registration Details:</strong>
          <div style={{ fontSize: '12px', marginTop: '5px' }}>
            <div>Scope: {swRegistration.scope}</div>
            <div>Active: {swRegistration.active ? 'Yes' : 'No'}</div>
            <div>Installing: {swRegistration.installing ? 'Yes' : 'No'}</div>
            <div>Waiting: {swRegistration.waiting ? 'Yes' : 'No'}</div>
          </div>
        </div>
      )}

      <div style={{ marginTop: '20px' }}>
        <button 
          onClick={checkServiceWorker}
          style={{ marginRight: '10px', padding: '8px 16px' }}
        >
          🔄 Refresh Status
        </button>
        
        {swRegistration && (
          <>
            <button 
              onClick={testNotification}
              style={{ marginRight: '10px', padding: '8px 16px' }}
            >
              🔔 Test Notification
            </button>
            
            <button 
              onClick={unregisterSW}
              style={{ padding: '8px 16px', backgroundColor: '#ff6b6b', color: 'white' }}
            >
              🗑️ Unregister
            </button>
          </>
        )}
      </div>

      <div style={{ marginTop: '20px', fontSize: '12px', color: '#666' }}>
        <strong>Debug Info:</strong>
        <div>User Agent: {navigator.userAgent}</div>
        <div>Location: {window.location.href}</div>
        <div>Is Secure Context: {window.isSecureContext ? 'Yes' : 'No'}</div>
      </div>
    </div>
  );
};

export default ServiceWorkerDebug;
